<template>
    <v-app>
      <p>Sitio en construcción</p> 
    </v-app>  
</template>

<script>
export default {
  name:"prepagoView",
  
}
</script>

<style>

</style>